import {
  Bell,
  Building2,
  ChartCandlestick,
  Code,
  Gauge,
  HomeIcon,
  Plus,
  RadioReceiver,
  RouterIcon,
  Settings,
  Sheet,
  SquareFunction,
  User2,
  Workflow,
} from "lucide-react";
import type { SoPermission } from "~/utils/permission";

export type ScRoute = {
  label: string;
  to: string;
  icon: React.ReactNode;
  children?: ScRoute[];
  permission?: SoPermission;
};

export const navRoutes: ScRoute[] = [
  {
    label: "home.nav",
    to: "/",
    icon: <HomeIcon className="w-5 h-5" />,
    permission: "Dashboard.View",
  },
  {
    label: "dashboard.nav",
    to: "/dashboard",
    icon: <Gauge className="w-5 h-5" />,
    permission: "Dashboard.View",
  },

  {
    label: "company.nav",
    to: "/company",
    icon: <Building2 className="w-5 h-5" />,
    permission: "Company.View",
    children: [
      {
        label: "company.navUsers",
        to: "/company/users",
        icon: <User2 className="w-5 h-5" />,
        permission: "Company.View",
      },
      {
        label: "company.navSettings",
        to: "/company/settings",
        icon: <Settings className="w-5 h-5" />,
        permission: "Company.Update",
      },
    ],
  },

  {
    label: "nodes.nav",
    to: "/nodes",
    icon: <RadioReceiver className="w-5 h-5" />,
    permission: "Tag.View",
    children: [
      {
        label: "nodes.nav",
        to: "/nodes",
        icon: <Sheet className="w-5 h-5" />,
        permission: "Tag.View",
      },
      {
        label: "nodes.navCreate",
        to: "/nodes/create",
        icon: <Plus className="w-5 h-5" />,
        permission: "Tag.Create",
      },
    ],
  },

  {
    label: "gateways.nav",
    to: "/gateways",
    icon: <RouterIcon className="w-5 h-5" />,
    permission: "Gateways.View",
  },

  {
    label: "manage.nav",
    to: "/manage",
    icon: <ChartCandlestick className="w-5 h-5" />,
    children: [
      {
        label: "formulas.nav",
        to: "/formulas",
        icon: <SquareFunction className="w-5 h-5" />,
        permission: "Formula.View",
      },

      {
        label: "alarms.nav",
        to: "/alarms",
        icon: <Bell className="w-5 h-5" />,
        permission: "Alarm.View",
      },

      {
        label: "reports.nav",
        to: "/reports",
        icon: <Sheet className="w-5 h-5" />,
        permission: "Report.View",
      },

      {
        label: "actions.nav",
        to: "/actions",
        icon: <Workflow className="w-5 h-5" />,
        permission: "Actions.View",
      },

      {
        label: "scripts.nav",
        to: "/scripts",
        icon: <Code className="w-5 h-5" />,
        permission: "Script.View",
      },
    ],
  },

  {
    label: "settings.nav",
    to: "/settings",
    icon: <Settings className="w-5 h-5" />,
    permission: "CompanySettings.View",
    children: [
      {
        label: "settings.navCompany",
        to: "/settings/company",
        icon: <Building2 className="w-5 h-5" />,
        permission: "CompanySettings.Update",
      },
    ],
  },
];
